<template>
  <div v-if="idxPatients" v-cloak>
    <div class="container container-fluid bg--gen-positive">
      <button class="btn btn-info btn-sm float-right" @click="routeNewIdx()">Skapa ny indexpatient</button>
      <h1 class="pull-left text-muted">Index patienter - {{noOfIdxPatients}} st</h1>
      <div class="clearfix"></div>
      <div class="table-responsive">
        <vue-good-table :columns="columns" :rows="idxPatients" :search-options="{
            enabled: true,
            placeholder: 'Sök',
          }" :sort-options="{
            enabled: true,
            initialSortBy: {field: 'indexPatientId', type: 'desc'}
          }">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'indexPatientId'">
              <router-link :to="{ name: 'indexpatient', params: { id: (props.row.indexPatientId) }}">
                {{ props.row.indexPatientId }}
              </router-link>
            </span>
            <span v-else-if="props.column.field == 'ssn'">
              <details>
                <summary>Personnummer</summary>
                {{ formatPnr(props.row.ssn) }}
              </details>
            </span>
            <span v-else-if="props.column.field == 'status'">
              {{ getStatus(props.row.status) }}
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
          <div slot="emptystate">
            Det finns inga indexpatienter
          </div>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { getIdxStatus } from '../plugins/status_idx'
import $ from 'jquery'

export default {
  name: 'indexpatients',
  components: {
  },
  data () {
    return {
      idxPatients: [],
      columns: [
        {
          label: 'Idx.ID',
          field: 'indexPatientId',
          type: 'number'
        },
        {
          label: 'PNR',
          field: 'ssn',
          type: 'text'
        },
        {
          label: 'Efternamn',
          field: 'lastName',
          type: 'text'
        },
        {
          label: 'Förnamn',
          field: 'firstName',
          type: 'text'
        },
        {
          label: 'Mutation',
          field: 'mutation',
          type: 'text'
        },
        {
          label: 'Status',
          field: 'status',
          type: 'text',
          sortFn: this.sortStatus
        },
        {
          label: 'Inbjudna',
          field: 'numberOfInvited',
          type: 'number'
        },
        {
          label: 'Pågående',
          field: 'numberInProgress',
          type: 'number'
        },
        {
          label: 'Klara',
          field: 'numberEvaluated',
          type: 'number'
        }
      ]
    }
  },
  methods: {
    sortStatus (x, y, col, rowX, rowY) {
      const xRow = this.getStatus(rowX.status)
      const yRow = this.getStatus(rowY.status)
      return (xRow.toLowerCase() < yRow.toLowerCase() ? -1 : (xRow.toLowerCase() > yRow.toLowerCase() ? 1 : 0))
    },
    getStatus (status) {
      return getIdxStatus(status)
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    formatPnr (ssn) {
      if (ssn) {
        const pnr = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return pnr
      }
      return '-'
    },
    routeNewIdx () {
      sessionStorage.removeItem('patientToBeConverted')
      this.$router.push({
        name: 'createnewidx',
        params: { patientType: 2 }
      })
    }
  },
  computed: {
    noOfIdxPatients () {
      return this.idxPatients.length
    }
  },
  beforeMount () {
    let loader = this.$loading.show()
    axios._get(config.indexPatientUri + config.allUri).then(response => {
      this.idxPatients = response.data.indexPatients
      this.idxPatients = this.idxPatients.filter(idx => !idx.geneNegative)
      loader.hide()
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location.href = window.location.origin.concat('/error')
      } else {
        console.log('Could not get indexpatients: ' + error)
        loader.hide()
      }
    })
  },
  created () {
    setTimeout(() => {
      $('.vgt-table').css('font-size', '14px')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.pull-left {
  text-align: left;
}
.table-responsive {
  margin-top: 1vh;
}
.float-right {
  margin-top: 1vh;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexPatients.vue